<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
import * as echarts from 'echarts';
require('echarts/theme/macarons') // echarts theme
import resize from './mixins/resize'

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    pieData: {
      type: Array,
    }
  },
  data() {
    return {
      chart: null,
      total: 0
    }
  },
  mounted() {
    this.pieData.forEach((item)=>{
       this.total+= Math.round(Number(item.value),2);
    })
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, 'macarons')
      const text = this.className === 'today' ? `总量\n${this.total}公斤` : `总量\n${this.total}吨`
      const tooltipText =  this.className === 'today' ?`{b} :<br/> {c}公斤 ({d}%)`: `{b} :<br/> {c}吨 ({d}%)`

      this.chart.setOption({
        title: {
          text:text,
          subtext:'',
          left: '23%',
          top:'25%',
          textStyle:{
            fontSize: 12,
            fontWeight: 'bold',
            color: '#E1E6E6'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: tooltipText
        },
        legend: {
          origin:'vertical',
          left: '0',
          bottom: '40',
          data: ['可回收物', '其他',],
          textStyle:{
            color: '#E1E6E6'
          }
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: ['30%', '50%'],
            center:['30%', '30%'],
            avoidLabelOverlap: false,
            label: {
               show: true,
               formatter: '{d}%'
            },
            labelLine: {
              length:6,
            },
            data: this.pieData,
            animationDuration: 2600
          }
        ],
        label: {
          normal: {
              formatter: '{b}: {d}%' // 显示标签文本，如：名称: 百分比
          },
          emphasis: { // 高亮时的样式设置
              show: true
          }
        },
        
      })
    }
  }
}
</script>
